import { getDirectusToken } from '../../../utils/localStorage';
import { loginDirectus } from './login';

const DIRECTUS_URL = process.env.REACT_APP_DIRECTUS_URL;
const UTILITY_BILL_COLLECTION = process.env.REACT_APP_DIRECTUS_UTILITY_BILL_COLLECTION || 'utility_bill';

async function fetchWithAuth(url, options = {}, { user, password, signal } = {}) {
  let token = getDirectusToken();
  if (!token && user && password) {
    token = await loginDirectus(user, password);
  }
  let response = await fetch(url, {
    ...options,
    headers: { ...options.headers, ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    signal
  });
  if (response.status === 401 && user && password) {
    token = await loginDirectus(user, password);
    response = await fetch(url, {
      ...options,
      headers: { ...options.headers, ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      signal
    });
  }
  return response;
}

export async function getUtilityBills({ orgUnit, signal, user, password } = {}) {
  if (!DIRECTUS_URL) throw new Error('REACT_APP_DIRECTUS_URL fehlt.');
  const params = new URLSearchParams({
    sort: '-date_created,-id',
    // document = Relation über utility_bill_files (nur utility_bill_id, directus_files_id); filename_download liegt in directus_files
    fields: [
      'id',
      'status',
      'date_created',
      'chargepoint',
      'user_electrictiy_tariff',
      'document.directus_files_id',
      'org_unit'
    ].join(',')
  });
  if (orgUnit != null && orgUnit !== '') {
    params.set('filter[org_unit][_eq]', orgUnit);
  }
  const url = `${DIRECTUS_URL.replace(/\/$/, '')}/items/${UTILITY_BILL_COLLECTION}?${params.toString()}`;
  const response = await fetchWithAuth(url, {}, { user, password, signal });
  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(`Directus utility_bill: ${response.status} ${text}`);
  }
  const payload = await response.json();
  return Array.isArray(payload?.data) ? payload.data : [];
}
